import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {User} from "../../models";


@Component({
    selector: 'work-time-details-dialog',
    templateUrl: './workTimeDetails.component.html',
    styleUrls: ['./workTimeDetails.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class WorkTimeDetailsDialogComponent {
    action: string;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    editMode: boolean = false;
    date: string = '';
    user: User;

    constructor(
        public matDialogRef: MatDialogRef<WorkTimeDetailsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        public _matDialog: MatDialog,
    ) {
        this.user = _data.user;
        this.date = _data.date;
        this.translationLoader.loadTranslations(polish);
    }
}
